<script setup>
import { defineProps, onMounted, onUnmounted, reactive, ref, watch } from "vue";
import { io } from "socket.io-client";
import { isArray } from "@apollo/client/utilities";
import { formatDate, formatNewDate, getTime } from "@/utils/datetime";

const URL = process.env.VUE_APP_SERVER_URL;

const state = reactive({
  connected: false,
});

const matches = ref([]);

const props = defineProps({
  documentId: String,
  tournament: {
    type: Object,
    default: null,
  },
});

const tournamentId = ref(props.documentId);

watch(
  () => props.tournament,
  (tournament) => {
    if (tournament) {
      tournamentId.value = tournament.documentId;

      if (state.connected && tournamentId.value) {
        socket.emit("subscribeToListMatch", tournamentId.value);
      }
    } else {
      console.log("no field");
    }
  },
);

const socket = io(URL, {
  reconnection: true, // Automatically reconnect if disconnected
});

// Lifecycle hooks
onMounted(() => {
  socket.on("connect", () => {
    state.connected = true;

    if (tournamentId.value) {
      socket.emit("subscribeToListMatch", tournamentId.value);
    }
  });

  socket.on("listTourMatchUpdated", (newEntry) => {
    matches.value = newEntry;
  });
});

onUnmounted(() => {
  // Hủy đăng ký trước khi ngắt kết nối
  if (tournamentId.value) {
    socket.emit("unsubscribeFromMatch", tournamentId);
  }
  socket.disconnect();
});

const renderSetData = (score_detail, num = 0, set = 0) => {
  if (!score_detail) return "";

  let scrore_arr;
  try {
    scrore_arr = JSON.parse(score_detail);
  } catch (e) {
    console.error("Invalid score_detail JSON:", e);
    return "";
  }

  const rawItem = scrore_arr[num];
  if (!rawItem) return "";

  let setData;

  try {
    setData = Array.isArray(rawItem) ? rawItem : JSON.parse(rawItem);
  } catch (e) {
    console.error("Invalid set data JSON:", e);
    return "";
  }

  return setData[set] !== undefined ? setData[set] : "";
};

const renderName = (player) => {
  if (!player) return "";
  const fistName = player?.first_name ?? "";
  const middleName = player?.middle_name ?? "";
  const lastName = player?.last_name ?? "";

  return `${fistName} ${middleName} ${lastName}`;
};
</script>

<template>
  <div class="mb-2">
    <div class="table-responsive table-datatble">
      <table class="table table-borderless dashboard-card-table">
        <colgroup>
          <col width="10%" />
          <col width="10%" />
          <col width="30%" />
          <col width="x" />
          <col width="30%" />
        </colgroup>
        <thead class="thead-light">
          <tr>
            <th>Mã trận</th>
            <th>Thời gian</th>
            <th>Đội 1</th>
            <th>Tỉ số</th>
            <th>Đội 2</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="match in matches" :key="match.id">
            <td>
              <h6>{{ match.match_code }}</h6>
            </td>
            <td>
              <p>{{ formatNewDate(match.start_date) }}</p>
              <p>{{ getTime(match.start_date) }}</p>
            </td>
            <td>
              <h6>
                {{ renderName(match?.tour_player_team_1?.player_1) }}
                <br />
                {{ renderName(match?.tour_player_team_1?.player_2) }}
              </h6>
            </td>
            <td>
              <h5 class="text-danger">
                {{ match?.score ? JSON.parse(match.score).join(" - ") : "" }}
              </h5>
              <div
                class="d-flex flex-column justify-content-start align-items-start mt-2 small"
              >
                <span
                  >G1: {{ renderSetData(match.score_detail, 0, 0) }} -
                  {{ renderSetData(match.score_detail, 0, 1) }}</span
                >
                <span
                  >G2: {{ renderSetData(match.score_detail, 1, 0) }} -
                  {{ renderSetData(match.score_detail, 1, 1) }}</span
                >
                <span
                  >G3: {{ renderSetData(match.score_detail, 2, 0) }} -
                  {{ renderSetData(match.score_detail, 2, 1) }}</span
                >
              </div>
            </td>
            <td>
              <h6>
                {{ renderName(match?.tour_player_team_2?.player_1) }}
                <br />
                {{ renderName(match?.tour_player_team_2?.player_2) }}
              </h6>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style scoped></style>
